module.exports = "/_next/static/images/game-2-menu-double-tap-2ac184b1420739b7bc1ef906d0afba24.png";